import { useCallback } from 'react';

import { ActionDialogType } from 'components/ActionDialog/constants';
import { useActiveActionDialogType, useAdditionalParamsDialog } from 'components/ActionDialog/useActionDialogParams';
import { Permission } from 'interfaces/permissionOption';
import { usePermissions } from 'utils/usePermissions';

import { getMarkerNamingAdditionalParams } from './markerNamingDialogParams';

export const useOpenBulkMarkerNamingDialog = () => {
  const { hasPermission } = usePermissions();
  const canOpenMarkerNamingDialog = hasPermission(Permission.EditQCMarkers);
  const [, setCurrentActionItemType] = useActiveActionDialogType();
  const [, updateAdditionalParams] = useAdditionalParamsDialog();

  const openMarkerNamingDialog = useCallback(
    ({ slideId, caseId }: { slideId?: string; caseId?: string | number } = {}) => {
      if (!canOpenMarkerNamingDialog) {
        return false;
      }

      updateAdditionalParams(getMarkerNamingAdditionalParams({ slideId, caseId }));
      setCurrentActionItemType(ActionDialogType.BulkMultiplexMarkerNaming);
      return true;
    },
    [canOpenMarkerNamingDialog, setCurrentActionItemType, updateAdditionalParams]
  );

  return {
    canOpenMarkerNamingDialog,
    openMarkerNamingDialog,
  };
};
